{
  "items": [
    {
      "fileName": "GENERIC-NatureLandscape-01.mp4",
      "description": "The video shows an aerial drone view looking down at a winding mountain road that curves and loops through a valley. The road is a light gray, paved surface with visible lane markings, curving in sharp switchback turns through rolling hills covered in autumn colored vegetation, including orange, gold, and rust colored grass and shrubs, along with clusters of dark green pine trees and golden yellow larch trees. In the upper right portion of the frame, steep gray rock cliffs and mountainsides rise sharply, with patches of green pine trees clinging to the slopes. Small wood cabins or chalets with dark roofs are scattered across the landscape, along with a small pond visible on the right side. The lighting is warm and golden, consistent with early morning or late afternoon sunlight, with a bright lens flare visible in the upper left portion of the frame where the sun is positioned low near the horizon. The color palette is warm and rich, dominated by orange, gold, rust, and green tones, with gray from the road and rock cliffs. The composition is a wide, expansive aerial shot, looking down at an angle, with the winding road curving diagonally across the frame. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and warm, golden hour lighting.",
      "keyElements": [
        "road",
        "hills",
        "trees",
        "cliffs",
        "cabins",
        "pond",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "expansive",
        "aerial",
        "wide shot",
        "golden hour",
        "warm lighting",
        "natural light",
        "warm tone",
        "lens flare",
        "autumn",
        "fall",
        "travel",
        "nature",
        "road",
        "mountain",
        "winding road",
        "orange",
        "gold",
        "green",
        "cliffs",
        "cabins",
        "trees",
        "larch",
        "pine"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-02.mp4",
      "description": "The video shows an aerial drone view of a steep, lush green mountain ridge overlooking the ocean. The ridge is covered in dense green vegetation, shrubs, and trees, with exposed gray, tan colored rock visible on a cliff face in the left foreground. The mountainside slopes steeply downward toward a flat coastal plain in the distance, showing patches of green agricultural fields and small structures near the shoreline. The ocean is visible in the upper right portion of the frame, a deep blue color with white waves breaking near the coastline. The sky above is light blue with soft white clouds scattered across it. The lighting is bright and natural, consistent with daytime sunlight, creating strong highlights on the ridge tops and softer shadows in the valleys between ridges. The color palette is vibrant and rich, dominated by green, blue, and tan tones. The composition is a wide, expansive aerial shot, with the mountain ridge filling the left and lower portions of the frame and the ocean and sky filling the upper right portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, natural lighting.",
      "keyElements": [
        "ridge",
        "rock cliff",
        "vegetation",
        "ocean",
        "coastline",
        "fields",
        "clouds",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "expansive",
        "aerial",
        "wide shot",
        "bright lighting",
        "natural light",
        "vibrant",
        "tropical",
        "travel",
        "nature",
        "mountain",
        "ridge",
        "ocean",
        "green",
        "blue",
        "tan",
        "cliff",
        "coastline",
        "clouds"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-03.mp4",
      "description": "The video shows an aerial drone view looking down at a dense pine forest filling a mountain valley, with thick fog or mist drifting between and above the treetops. The trees are tall, dark green pine and fir trees, densely packed together, with the tops of individual trees visible poking through patches of fog in the foreground. The fog is illuminated with a warm, golden, amber glow in the center of the frame, suggesting sunlight filtering through the mist, while the fog appears cooler and grayer toward the edges of the frame. Additional forested hills and ridges are visible in the background, partially obscured by haze. The lighting is soft and diffused, consistent with early morning light filtering through fog, creating a warm glow in the central valley area while the surrounding forest remains in cooler, muted tones. The color palette is moody and atmospheric, dominated by dark green, gray, and warm amber tones. The composition is a wide, expansive aerial shot, looking down at an angle, with fog and treetops filling the entire frame. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a moody, atmospheric look.",
      "keyElements": [
        "pine forest",
        "trees",
        "fog",
        "mist",
        "valley",
        "hills",
        "lighting"
      ],
      "attributes": [
        "moody",
        "atmospheric",
        "scenic",
        "aerial",
        "wide shot",
        "soft lighting",
        "natural light",
        "warm tone",
        "cool tone",
        "misty",
        "foggy",
        "travel",
        "nature",
        "forest",
        "pine trees",
        "fog",
        "mist",
        "green",
        "amber",
        "gray",
        "valley"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-04.mp4",
      "description": "The video shows an aerial view of several wind turbines positioned across rolling hills at sunset. The wind turbines are tall, white colored structures with three long blades each, standing atop grassy, green and brown colored hills covered in low shrubs and vegetation. One large wind turbine is positioned prominently in the right foreground, with its blades angled diagonally across the frame, while additional turbines are visible receding into the distance on the left side of the frame. The sky above is filled with dramatic clouds in gray and white tones, with the sun positioned low near the horizon on the right side, creating a bright golden glow and a strong lens flare that radiates across the lower right portion of the frame. The lighting is warm and dramatic, consistent with sunset lighting, creating silhouetted effects on the turbines and hills against the bright sky. The color palette is warm and rich, dominated by gold, orange, and amber tones near the horizon, transitioning to cooler gray and blue tones in the upper sky. The composition is a wide, expansive aerial shot, with the turbines positioned across the middle of the frame and the dramatic sky filling the upper portion. The visual style is photographic, realistic, and resembles an energy or environmental style stock video with a wide depth of field and dramatic, warm sunset lighting.",
      "keyElements": [
        "wind turbines",
        "hills",
        "clouds",
        "sky",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "dramatic",
        "expansive",
        "aerial",
        "wide shot",
        "sunset",
        "golden hour",
        "warm lighting",
        "natural light",
        "warm tone",
        "lens flare",
        "energy",
        "renewable energy",
        "environmental",
        "nature",
        "wind turbine",
        "windmill",
        "hills",
        "clouds",
        "sky",
        "gold",
        "orange"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-05.mp4",
      "description": "The video shows an aerial drone view looking directly down at ocean waves washing onto a sandy beach. The ocean water is a rich turquoise, teal color in the upper portion of the frame, transitioning to a bright white as waves break and create sea foam along the shoreline. The wet sand is a light tan, beige color, showing dark, textured patterns and rivulets left behind by receding waves in the lower portion of the frame. The wave breaks in a long, curving line diagonally across the middle of the frame, separating the ocean from the beach. The lighting is bright and even, consistent with clear daytime sunlight, creating sparkling highlights on the water and foam. The color palette is vibrant and bright, dominated by turquoise, teal, white, and tan tones. The composition is a direct overhead, top down aerial shot, with the ocean filling the upper portion of the frame and the sandy beach filling the lower portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, vibrant coastal lighting.",
      "keyElements": ["ocean", "waves", "foam", "beach", "sand", "lighting"],
      "attributes": [
        "scenic",
        "vibrant",
        "aerial",
        "overhead",
        "top down",
        "bright lighting",
        "natural light",
        "coastal",
        "travel",
        "nature",
        "ocean",
        "waves",
        "foam",
        "beach",
        "sand",
        "turquoise",
        "teal",
        "white",
        "tan"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-06.mp4",
      "description": "The video shows an aerial drone view of a misty countryside landscape at sunrise, featuring a calm pond surrounded by grassy hills and trees. The pond has a smooth, glassy, gray green colored surface, reflecting the surrounding vegetation, and is bordered by tall grass and reeds. Rolling green hills covered in grass and clusters of trees extend into the background, with a dense forest visible along the edges of the frame. Thick fog or mist rises from the fields and drifts between the trees, illuminated by bright golden sunlight streaming through gaps in the tree line in the upper left portion of the frame, creating visible sun rays or god rays. The lighting is soft, warm, and atmospheric, consistent with early morning sunrise light filtering through mist, creating a glowing, hazy effect. The color palette is warm and soft, dominated by green, gold, and amber tones, with gray green from the pond water. The composition is a wide, expansive aerial shot, looking down at an angle, with the pond positioned in the lower right portion of the frame and the misty, sunlit fields filling the upper portion. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a warm, atmospheric, dreamy look.",
      "keyElements": [
        "pond",
        "hills",
        "trees",
        "fog",
        "mist",
        "sun rays",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "atmospheric",
        "dreamy",
        "expansive",
        "aerial",
        "wide shot",
        "sunrise",
        "golden hour",
        "soft lighting",
        "natural light",
        "warm tone",
        "misty",
        "foggy",
        "sun rays",
        "travel",
        "nature",
        "pond",
        "hills",
        "trees",
        "green",
        "gold",
        "fog",
        "mist"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-07.mp4",
      "description": "The video shows a ground level view of a calm lake at sunrise, with a low lying layer of mist or fog hovering just above the water's surface. The lake water is a soft pink, peach colored tone, reflecting the warm sky above, with gentle ripples visible on the surface. A line of dense trees, including a drooping willow tree on the left side of the frame, borders the far shore of the lake, appearing as dark silhouettes against the warm, hazy sky. Rolling hills and distant mountains are visible in the background, softened by atmospheric haze. The lighting is warm and soft, consistent with early morning sunrise light, creating a glowing, hazy pink and gold atmosphere throughout the scene. The color palette is warm and soft, dominated by pink, peach, gold, and muted green tones. The composition is a wide, horizontal shot, with the tree line and mountains positioned in the upper third of the frame and the misty lake water filling the lower two thirds. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a soft, dreamy, atmospheric look.",
      "keyElements": [
        "lake",
        "mist",
        "fog",
        "trees",
        "willow tree",
        "mountains",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "atmospheric",
        "dreamy",
        "peaceful",
        "serene",
        "wide shot",
        "sunrise",
        "soft lighting",
        "natural light",
        "warm tone",
        "misty",
        "foggy",
        "travel",
        "nature",
        "lake",
        "water",
        "mist",
        "fog",
        "trees",
        "willow",
        "mountains",
        "pink",
        "peach",
        "gold"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-08.mp4",
      "description": "The video shows a close up view of tall, silhouetted grass stalks and seed heads swaying against a sunset sky. The grass stalks are thin and dark, appearing as silhouettes with feathery seed heads at the top, positioned in the foreground and out of focus in some areas. The sun is visible as a small, bright, glowing orb low on the horizon in the center of the frame, partially obscured by the grass stalks. The sky transitions from a warm orange and pink near the horizon to a cooler blue and teal higher in the frame, with a hazy silhouette of distant hills or mountains visible along the horizon line. The lighting is warm and soft, consistent with sunset lighting, creating a backlit, glowing effect on the grass and a gentle gradient across the sky. The color palette is warm and soft, dominated by orange, pink, and gold tones near the horizon, transitioning to blue and teal tones higher in the sky. The composition is a close up, closeup, wide angle framing, with the grass filling the foreground and the sunset sky filling the background. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field and warm, backlit sunset lighting.",
      "keyElements": [
        "grass",
        "seed heads",
        "sun",
        "sky",
        "hills",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "peaceful",
        "serene",
        "close up",
        "closeup",
        "silhouette",
        "sunset",
        "backlight",
        "golden hour",
        "warm lighting",
        "natural light",
        "warm tone",
        "cool tone",
        "nature",
        "lifestyle",
        "grass",
        "seed heads",
        "sun",
        "sky",
        "orange",
        "pink",
        "blue",
        "teal",
        "hills"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-09.mp4",
      "description": "The video shows an aerial drone view of a rugged, rocky ocean coastline, with waves crashing against dark, jagged rock formations. The ocean water displays varying shades of blue, from deep navy blue further from shore to bright turquoise and white sea foam where waves break against the rocks. The coastline features tall, layered rock cliffs in dark gray and brown tones, with patches of green and orange vegetation growing along the clifftops. A grassy, green and tan colored plateau extends along the top of the cliffs in the upper right portion of the frame. The lighting is bright and natural, consistent with clear daytime sunlight, creating sharp highlights on the wave crests and defined shadows within the rock formations. The color palette is vibrant and rich, dominated by navy blue, turquoise, white, and gray tones, with green and orange accents from the clifftop vegetation. The composition is a wide, expansive aerial shot, with the ocean filling the left portion of the frame and the rocky coastline and cliffs filling the right portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, dramatic coastal lighting.",
      "keyElements": [
        "ocean",
        "waves",
        "rocks",
        "cliffs",
        "vegetation",
        "plateau",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "dramatic",
        "rugged",
        "expansive",
        "aerial",
        "wide shot",
        "bright lighting",
        "natural light",
        "vibrant",
        "coastal",
        "travel",
        "nature",
        "ocean",
        "waves",
        "rocks",
        "cliffs",
        "navy blue",
        "turquoise",
        "white",
        "gray",
        "green"
      ]
    },
    {
      "fileName": "GENERIC-NatureLandscape-10.mp4",
      "description": "The video shows an aerial drone view flying low over a snow covered mountain ridge. The ridge is entirely blanketed in thick, white snow, with a narrow, jagged ridgeline running diagonally across the frame, featuring exposed patches of dark brown and reddish rock protruding through the snow near the top of the ridge. Additional snow covered mountain peaks are visible in the background, extending toward the horizon on the left side of the frame. The sky above is a deep blue color with wispy, streaking white clouds, and the sun is positioned high in the sky, partially obscured by clouds, creating a bright glow and subtle lens flare in the upper portion of the frame. The lighting is bright and crisp, consistent with clear high altitude daytime sunlight, creating strong highlights on the snow and defined shadows within the ridge's contours. The color palette is bright and cool, dominated by white, blue, and gray tones, with brown and reddish accents from the exposed rock. The composition is a wide, dynamic aerial shot, following the line of the ridge diagonally across the frame. The visual style is photographic, realistic, and resembles an adventure or travel style stock video with a wide depth of field and bright, crisp high altitude lighting.",
      "keyElements": [
        "mountain ridge",
        "snow",
        "peaks",
        "rock",
        "sky",
        "clouds",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "scenic",
        "dramatic",
        "expansive",
        "aerial",
        "wide shot",
        "bright lighting",
        "natural light",
        "cool tone",
        "crisp",
        "adventure",
        "travel",
        "nature",
        "mountain",
        "ridge",
        "snow",
        "peaks",
        "rock",
        "white",
        "blue",
        "clouds",
        "sky"
      ]
    }
  ]
}
